module.exports = __webpack_public_path__ + "img/bsan.53c848c6.webp";